const API_BASE = '/api';

let csrfToken = null;

export async function fetchCsrfToken() {
  const response = await fetch(`${API_BASE}/csrf/`, {
    credentials: 'include',
  });
  if (!response.ok) {
    throw new Error('Failed to fetch CSRF token');
  }
  const data = await response.json();
  csrfToken = data.csrfToken;
  return data;
}

export async function submitRightOfEntry(data) {
  if (!csrfToken) {
    await fetchCsrfToken();
  }

  const response = await fetch(`${API_BASE}/right-of-entry/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRFToken': csrfToken,
    },
    credentials: 'include',
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || 'Failed to submit form');
  }

  return response.json();
}
